<script lang="ts">
  import Check from "svelte-radix/Check.svelte";
  import CaretSort from "svelte-radix/CaretSort.svelte";
  import { createEventDispatcher, tick } from "svelte";
  import * as Command from "$lib/components/ui/command/index.js";
  import * as Popover from "$lib/components/ui/popover/index.js";
  import { Button } from "$lib/components/ui/button/index.js";
  import { cn } from "$lib/utils.js";
  import { getTranslation } from "$src/presentation/core/TranslatedTextUtils";
  import { languageCode } from "$src/presentation/core/languageCode";
  import { type DeliveryType } from "$src/domain/projects/deliveries/DeliveryType";
  import { useDeliveryTypes } from "../hooks/useDeliveryTypes";
  import { get } from "svelte/store";

  let open = false;

  export let groupStoreId: number;
  export let value: DeliveryType | undefined;

  $: deliveryTypesQuery = useDeliveryTypes(groupStoreId);

  const dispatch = createEventDispatcher();

  function handleSelect(currentValue: string, ids: any) {
    const selectedValue = get(deliveryTypesQuery).data?.find(
      (f) => f.id.toString() === currentValue
    );
    if (selectedValue) {
      value = selectedValue;
      dispatch("change", { value: selectedValue });
    }

    closeAndFocusTrigger(ids.trigger);
  }

  // We want to refocus the trigger button when the user selects
  // an item from the list so users can continue navigating the
  // rest of the form with the keyboard.
  function closeAndFocusTrigger(triggerId: string) {
    open = false;
    tick().then(() => {
      document.getElementById(triggerId)?.focus();
    });
  }
</script>

<Popover.Root bind:open let:ids>
  <Popover.Trigger asChild let:builder>
    <Button
      builders={[builder]}
      variant="outline"
      role="combobox"
      aria-expanded={open}
      class="w-[260px] justify-between font-normal"
    >
      {#if value}
        {getTranslation(value.translations, $languageCode)}
      {:else}
        {"select a delivery type"}
      {/if}
      <CaretSort class="ml-2 h-4 w-4 shrink-0 opacity-50" />
    </Button>
  </Popover.Trigger>
  <Popover.Content class="w-[260px] p-0">
    <Command.Root>
      <Command.Group>
        {#if $deliveryTypesQuery.isSuccess}
          {#each $deliveryTypesQuery.data as deliveryType}
            <Command.Item
              value={deliveryType.id.toString()}
              onSelect={(currentValue) => handleSelect(currentValue, ids)}
            >
              <Check
                class={cn(
                  "mr-2 h-4 w-4",
                  value?.id.toString() !== deliveryType.id.toString() &&
                    "text-transparent"
                )}
              />
              {getTranslation(deliveryType.translations, $languageCode)}
            </Command.Item>
          {/each}
        {/if}
      </Command.Group>
    </Command.Root>
  </Popover.Content>
</Popover.Root>
